module.exports = __webpack_public_path__ + "static/media/Maf_PromoMasculinidad_Home.3d898ba4.jpg";